import RecentCustomers from './recent_customers';

export default RecentCustomers;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/search/recent_customers/index.js